import { http } from '@/api/http';
import { ApiResponseBody, PaginatedBody, PaginationSearchParams } from '@/api/types';
import { getCommunicationApiUrl } from './communication.paths';
import { NotificationType } from './communication.types';
import { SettingsType } from '../user';

const getNotificationsList = async (params: PaginationSearchParams) => {
  const res = await http.get<ApiResponseBody<PaginatedBody<NotificationType>>>(
    getCommunicationApiUrl.notificationHub(),
    {
      params,
    },
  );
  return res.data.data;
};

const getSettings = async () => {
  const res = await http.get<ApiResponseBody<SettingsType>>(getCommunicationApiUrl.settings(), {});
  return res.data.data;
};

const updateSettings = async (data: SettingsType) => {
  const res = await http.put<ApiResponseBody<SettingsType>>(getCommunicationApiUrl.settings(), data);
  return res.data.data;
};

export const communicationApiFetcher = {
  getNotificationsList,
  getSettings,
  updateSettings,
};
